
import {RootStateType} from '../../store';

export const selectLoadingState = (report: RootStateType): string => {
    return report.reporting?.status;
};